/**
 * Accessible details-based show more for product description
 * - Uses <details> so it is keyboard and screen-reader friendly out of the box
 * - Hides the toggle entirely when content is shorter than the preview height
 */
(function () {
  const PREVIEW_PX = 200;

  function initDesc(container) {
    const details = container.querySelector('.product-desc__details');
    const preview = container.querySelector('.product-desc__preview');
    const content = container.querySelector('.product-desc__content');
    const summary = container.querySelector('.product-desc__toggle');
    if (!details || !preview || !content || !summary) return;

    // Clone first nodes into preview until height exceeds PREVIEW_PX
    preview.innerHTML = '';
    const working = content.cloneNode(true);
    // Remove ids to avoid duplicates
    working.removeAttribute('id');
    preview.appendChild(working);
    // Limit height by CSS; check if overflow is needed
    const needsToggle = content.scrollHeight > PREVIEW_PX + 10;
    if (!needsToggle) {
      container.classList.add('is-open');
      details.setAttribute('open', '');
      preview.style.display = 'none';
      summary.style.display = 'none';
    }

    const moreLabel = summary.querySelector('.text-more');
    const lessLabel = summary.querySelector('.text-less');

    function setState(expanded) {
      summary.setAttribute('aria-expanded', String(expanded));
      container.classList.toggle('is-open', expanded);
      if (moreLabel) {
        moreLabel.hidden = expanded;
        moreLabel.style.display = expanded ? 'none' : 'inline-flex';
      }
      if (lessLabel) {
        lessLabel.hidden = !expanded;
        lessLabel.style.display = expanded ? 'inline-flex' : 'none';
      }
    }

    details.addEventListener('toggle', () => {
      const expanded = details.open;
      setState(expanded);
      if (expanded) {
        // Scroll so that the first line of the expanded content is visible
        const y = content.getBoundingClientRect().top + window.pageYOffset - 130; // offset for sticky headers
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });

    // Initialize
    setState(details.open);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product__description .product-desc').forEach(initDesc);
  });
})();
